<template>
  <el-tooltip
    :disabled="!disabled"
    class="item"
    effect="light"
    :content="tooltipText"
    placement="bottom"
  >
    <el-upload
      :disabled="disabled"
      drag
      :class="disabled ? 'image-uploader disabled' : 'image-uploader'"
      action="#"
      :show-file-list="false"
      :auto-upload="false"
      :on-change="UploadFile"
    >
      <img
        v-if="base64"
        :src="base64"
        class="image"
      >
      <i
        v-else
        class="el-icon-camera image-uploader-icon"
      />
    </el-upload>
  </el-tooltip>
</template>

<script>
export default {
  name: 'Uploader',
  props: {
    base64: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tooltipText: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    convertFormat: ['heif', 'heifs', 'heic', 'heics'],
    allowedImageExtension: ['jpeg', 'jpg', 'png', 'jfif']
  }),
  computed: {
    fileUrl: {
      get: function () {
        return this.base64;
      },
      set: function (value) {
        this.$emit('update:base64', value);
      }
    }
  },
  methods: {
    UploadFile (file) {
      const sizeLimit = file.size / 1024 / 1024 < 10;

      var re = /(?:\.([^.]+))?$/,
          ext = re.exec(file.raw.name)[1];

      if (this.convertFormat.includes(ext.toLowerCase())) {
        this.$emit('showLoader');
        const data = new FormData();
        data.append('file', file.raw);

        this.$axios('/ImageConverter/ConvertToJpeg', {
          method: 'POST',
          headers: {'content-type': 'multipart/form-data'},
          data: data,
          responseType: 'arraybuffer'
        }).then((response) => {
          if (response.data){
            const imgStr = new Buffer.from(response.data, 'binary').toString('base64'),
                prefix = "data:" + response.headers["content-type"] + ";base64,";
            this.fileUrl = prefix + imgStr;
            this.$emit('imageUploaded');
          }
        }).catch(() => {
          this.$message.error('We couldn\'t convert your photo!');
          return false;
        });
      } else {
        if (!this.allowedImageExtension.includes(ext.toLowerCase())) {
          this.$message.error('Photo cannot be uploaded! Incorrect format!');
          return false;
        }
        if (!sizeLimit) {
          this.$message.error('Photo size can not exceed 10MB!');
          return false;
        }
        var self = this;
        var reader = new FileReader();
        reader.readAsDataURL(file.raw);
        reader.onloadend = function () {
          self.fileUrl = reader.result;
          self.$emit('imageUploaded');
        };
      }
    }
  }
};
</script>
